<template>
	<div class="magente-form-header puiformheader">
	</div>
</template>

<script>
import { PuiFormHeaderMixin } from '@Pui9Components';

export default {
	name: 'magente-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'magente'
		};
	},
	computed: {
	}
}
</script>
